import {
  HeaderBackButton as RNEHeaderBackButton,
  type HeaderBackButtonProps as RNEHeaderBackButtonProps
} from '@react-navigation/elements'
import { useIsFocused } from '@react-navigation/native'
import { IconChevronLeft } from '@tabler/icons-react-native'
import { clsx } from 'clsx'

import { Icon, type IconProps } from '@/components'

export interface HeaderBackButtonProps extends Omit<RNEHeaderBackButtonProps, 'children'> {
  className?: IconProps['className']
}

export const HeaderBackButton = ({ className, style, ...props }: HeaderBackButtonProps) => {
  const isFocused = useIsFocused()

  return isFocused ? (
    <RNEHeaderBackButton
      accessibilityLabel='Back to previous screen'
      backImage={() => (
        <Icon
          as={IconChevronLeft}
          className={clsx('h-6 w-6', className)}
          strokeWidth={2.5}
        />
      )}
      style={[
        {
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: 0,
          width: 40,
          height: 40,
          margin: 0
        },
        style
      ]}
      {...props}
    />
  ) : null
}
